import {
  Box,
  Divider,
  FormControlLabel,
  Switch,
  TextField,
  Typography,
} from '@material-ui/core';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  calendarOptions,
  detailsTickets,
  setDetailsData,
  tripData,
} from 'src/redux/Calendar/sliceCalendar';
import ForwardIcon from '@material-ui/icons/Forward';
import {
  ITicketDetails,
  ITicketsDetailsData,
} from 'src/redux/Calendar/interfaces';
import { getPlaceholderFromDefaultValues } from 'src/helpers/calendar/getNormalisedValueFromInput';
import { normalizeTime } from 'src/helpers/calendar/normalizeTime';
import { useStyles } from './styles';

interface ITicketMaster
  extends Omit<
    ITicketDetails,
    'is_disabled_ts' | 'calendar_id' | 'total' | 'sold' | 'sold_ts'
  > {}

export const TicketsMasterUpdateForm = ({
  comission,
  schedule_id,
}: {
  comission: string;
  schedule_id?: number;
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { ticket_type, rate_id } = useSelector(calendarOptions);
  const data = useSelector(tripData);
  const detailedData = useSelector(detailsTickets);
  const defaultTicket = data?.tickets.find((i) => i.id === ticket_type);
  const currentSchedule = data?.schedules.find((i) => i.id === schedule_id);

  const [state, setState] = useState<ITicketMaster>({
    price: null,
    strike_out: null,
    wholesale: null,
    commission: null,
    min: null,
    total_ts: null,
    disable_promos: '0',
    is_disabled: '0',
  });
  if (!defaultTicket || (schedule_id && !currentSchedule)) return null;

  const changeState = (data: Partial<ITicketMaster>) => {
    setState((prev) => ({ ...prev, ...data }));
  };

  const applyChanges = (name: keyof ITicketMaster) => {
    if (!detailedData) return;
    dispatch(
      setDetailsData(
        Object.keys(detailedData).reduce((acc: ITicketsDetailsData, curr) => {
          return {
            ...acc,
            [curr]: Object.keys(detailedData[curr]).reduce(
              (
                accD: {
                  [date: string]: ITicketDetails;
                },
                currD
              ) => {
                return {
                  ...accD,
                  [currD]: {
                    ...detailedData[curr][currD],
                    ...((!schedule_id || schedule_id === +curr) && {
                      [name]: state[name],
                    }),
                  },
                };
              },
              {}
            ),
          };
        }, {})
      )
    );
  };

  return (
    <Box
      bgcolor={schedule_id ? '#e6fcfa' : '#c0f3ef'}
      borderBottom={'0.8px solid rgba(0, 0, 0, 0.12)'}
      borderTop={!!schedule_id && '0.8px solid rgba(0, 0, 0, 0.12)'}
      px={3}
      position={!!schedule_id && 'sticky'}
      mt={!!schedule_id && 1}
      zIndex={10}
      top={0}>
      <Box py={0.5} display="flex" alignItems="center">
        {schedule_id ? (
          <Typography variant="body1">
            Bulk Update for{' '}
            <strong>
              {currentSchedule
                ? normalizeTime(currentSchedule.hour, currentSchedule.minute)
                : '-'}
            </strong>{' '}
            tickets
          </Typography>
        ) : (
          <Typography variant="button" style={{ fontWeight: 500 }}>
            Bulk Update for All Schedules
          </Typography>
        )}
      </Box>
      <Divider variant="fullWidth" />
      <Box
        display="flex"
        pb={2}
        pt={3}
        justifyContent="center"
        flexWrap="wrap"
        gridGap="10px">
        <Box mr={2} display="flex" alignItems="center">
          <TextField
            type="number"
            placeholder={getPlaceholderFromDefaultValues(
              defaultTicket.price,
              2
            )}
            value={state.price || ''}
            onChange={(e) => changeState({ price: e.target.value })}
            variant="outlined"
            className={classes.inputWrapper}
            InputProps={{
              style: {
                width: '120px',
                height: '40px',
                background: '#fff',
              },
            }}
            size="small"
            InputLabelProps={{
              shrink: true,
              style: {
                letterSpacing: '0.04em',
              },
            }}
            label="Rate"
          />
          <Box
            style={{ cursor: 'pointer' }}
            display="flex"
            ml={0.5}
            onClick={() => applyChanges('price')}>
            <ForwardIcon style={{ rotate: '90deg' }} />
          </Box>
        </Box>
        {/* <Box mr={2} display="flex" alignItems="center">
          <TextField
            type="number"
            placeholder={getPlaceholderFromDefaultValues(
              defaultTicket.strike_out,
              2
            )}
            value={state.strike_out || ''}
            onChange={(e) => changeState({ strike_out: e.target.value })}
            variant="outlined"
            className={classes.inputWrapper}
            InputProps={{
              style: {
                width: '120px',
                height: '40px',
                background: '#fff',
              },
            }}
            size="small"
            InputLabelProps={{
              shrink: true,
              style: {
                letterSpacing: '0.04em',
              },
            }}
            label="Strikeout"
          />
          <Box
            style={{ cursor: 'pointer' }}
            display="flex"
            ml={0.5}
            onClick={() => applyChanges('strike_out')}>
            <ForwardIcon style={{ rotate: '90deg' }} />
          </Box>
        </Box> */}
        {/* <Box mr={2} display="flex" alignItems="center">
          <TextField
            type="number"
            placeholder={getPlaceholderFromDefaultValues(comission)}
            value={state.commission || ''}
            onChange={(e) => changeState({ commission: e.target.value })}
            variant="outlined"
            className={classes.inputWrapper}
            InputProps={{
              style: {
                width: '120px',
                height: '40px',
                background: '#fff',
              },
            }}
            size="small"
            InputLabelProps={{
              shrink: true,
              style: {
                letterSpacing: '0.04em',
              },
            }}
            label="Margin"
          />
          <Box
            style={{ cursor: 'pointer' }}
            display="flex"
            ml={0.5}
            onClick={() => applyChanges('commission')}>
            <ForwardIcon style={{ rotate: '90deg' }} />
          </Box>
        </Box>
        <Box mr={2} display="flex" alignItems="center">
          <TextField
            type="number"
            onChange={(e) => changeState({ wholesale: e.target.value })}
            placeholder={getPlaceholderFromDefaultValues(
              defaultTicket.wholesale,
              2
            )}
            value={state.wholesale || ''}
            variant="outlined"
            className={classes.inputWrapper}
            InputProps={{
              style: {
                width: '120px',
                height: '40px',
                background: '#fff',
              },
            }}
            size="small"
            InputLabelProps={{
              shrink: true,
              style: {
                letterSpacing: '0.04em',
              },
            }}
            label="Net"
          />
          <Box
            style={{ cursor: 'pointer' }}
            display="flex"
            ml={0.5}
            onClick={() => applyChanges('wholesale')}>
            <ForwardIcon style={{ rotate: '90deg' }} />
          </Box>
        </Box> */}
        {!rate_id && (
          <>
            {/* <Box mr={2} display="flex" alignItems="center">
              <TextField
                type="number"
                value={state.min || ''}
                onChange={(e) => changeState({ min: e.target.value })}
                placeholder={getPlaceholderFromDefaultValues(defaultTicket.min)}
                variant="outlined"
                className={classes.inputWrapper}
                InputProps={{
                  style: {
                    width: '120px',
                    height: '40px',
                    background: '#fff',
                  },
                }}
                size="small"
                InputLabelProps={{
                  shrink: true,
                  style: {
                    letterSpacing: '0.04em',
                  },
                }}
                label="Min"
              />
              <Box
                style={{ cursor: 'pointer' }}
                display="flex"
                ml={0.5}
                onClick={() => applyChanges('min')}>
                <ForwardIcon style={{ rotate: '90deg' }} />
              </Box>
            </Box> */}
            <Box mr={2} display="flex" alignItems="center">
              <TextField
                type="number"
                value={state.total_ts || ''}
                onChange={(e) => changeState({ total_ts: e.target.value })}
                placeholder={getPlaceholderFromDefaultValues(
                  defaultTicket.total_ts
                )}
                variant="outlined"
                className={classes.inputWrapper}
                InputProps={{
                  style: {
                    width: '120px',
                    height: '40px',
                    background: '#fff',
                  },
                }}
                size="small"
                InputLabelProps={{
                  shrink: true,
                  style: {
                    letterSpacing: '0.04em',
                  },
                }}
                label="Total"
              />
              <Box
                style={{ cursor: 'pointer' }}
                display="flex"
                ml={0.5}
                onClick={() => applyChanges('total_ts')}>
                <ForwardIcon style={{ rotate: '90deg' }} />
              </Box>
            </Box>
            <Box display="flex" ml={6}>
              {/* <Box display="flex" alignItems="center" mr={4}>
                <FormControlLabel
                  control={<Switch className={classes.customSwitch} />}
                  label="Disable Promos"
                  checked={Boolean(
                    state.disable_promos && +state.disable_promos
                  )}
                  onChange={(_, checked) =>
                    changeState({ disable_promos: checked ? "1" : "0" })
                  }
                />
                <Box
                  style={{ cursor: "pointer" }}
                  display="flex"
                  onClick={() => applyChanges("disable_promos")}
                >
                  <ForwardIcon style={{ rotate: "90deg" }} />
                </Box>
              </Box> */}
              <Box display="flex" alignItems="center">
                <FormControlLabel
                  control={<Switch className={classes.customSwitch} />}
                  label="Stop Sell"
                  checked={Boolean(state.is_disabled && +state.is_disabled)}
                  onChange={(_, checked) =>
                    changeState({ is_disabled: checked ? '1' : '0' })
                  }
                />
                <Box
                  style={{ cursor: 'pointer' }}
                  display="flex"
                  onClick={() => applyChanges('is_disabled')}>
                  <ForwardIcon style={{ rotate: '90deg' }} />
                </Box>
              </Box>
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
};
